import React from "react";
import { IoMdClose } from "react-icons/io";
import BankStatementView from "app/components/imagesUploads/joint/BankStatementView";

interface ViewFilesModelProps {
  isOpen: boolean;
  onClose: () => void;
  uploadedFilesArray: any;
  handleDeleteImage: (index: number) => void;
}

const ViewFilesModel: React.FC<ViewFilesModelProps> = ({
  isOpen,
  onClose,
  uploadedFilesArray = [],
  handleDeleteImage,
}) => {
  if (!isOpen) return null;

  return (
    <div
      className=" fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50"
      // onClick={onClose}
    >
      <div
        className="h-[350px] scrollbar-thin scrollbar-thumb-gray-400 scrollbar-track-gray-100 bg-white p-6 rounded-lg shadow-lg max-w-md w-full mx-4"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex justify-between items-center">
          <h1 className="text-[#141340] font-Poppins font-bold text-[20px] mb-3">
            Uploaded Documents
          </h1>
          <IoMdClose className="text-[20px] cursor-pointer" onClick={onClose} />
        </div>
        <div className="max-h-60 overflow-y-auto scrollbar-thin scrollbar-thumb-gray-400 scrollbar-track-gray-100">
          {uploadedFilesArray?.slice(2)?.map((file: File, index: number) => {
            const FileName = file instanceof File ? file.name : file;
            return (
              <>
                <BankStatementView
                  key={index + 2}
                  fileName={FileName}
                  onDelete={() => handleDeleteImage(index + 2)}
                />
              </>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default ViewFilesModel;
